import { deviceItemsReducer, } from 'console/redux/devices/items/reducer';
import { treeLastUpdateTimeReducer } from 'console/redux/devices/time';
import { selectedDeviceIdReducer, } from 'console/redux/devices/selected-id';
import memoizeOne from 'memoize-one';
import { deviceTreeReducer } from 'console/redux/devices/tree/reducer';
import { devicesFromJSON } from 'console/device/utils';
import { deviceTreeWithId } from './utils';
const partialDeviceTreeReducer = memoizeOne((devices, tree_items) => (state = tree_items, action) => deviceTreeReducer(state, devices, action));
export const devicesReducer = (PRELOAD) => (state, action) => {
    // don't use combine reducer; he add undefined state every time
    return {
        items: deviceItemsReducer(PRELOAD)(state?.items, action),
        tree: partialDeviceTreeReducer(state?.items ?? devicesFromJSON(PRELOAD.devices), deviceTreeWithId(PRELOAD.device_tree))(state?.tree, action),
        tree_last_update_time: treeLastUpdateTimeReducer(state?.tree_last_update_time, action),
        selected_id: selectedDeviceIdReducer(state?.selected_id, action),
    };
};
